import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/** @param {{ query?: { isActive?: boolean, page?: number, limit?: number } }} [option] */
export const GetMainPlatforms = async (option) => {
  const response = await $api.get(Endpoints.LeadSource.GetMainPlatforms(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{
 *   name: string,
 *   logo?: string,
 *   requiredFields?: Array<{ id: string, name: string, order: number }>,
 *   isActive?: boolean
 * }} form
 */
export const CreateMainPlatform = async (form) => {
  const response = await $api.post(
    Endpoints.LeadSource.CreateMainPlatform(),
    form
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{
 *   params: { id: string },
 *   body: {
 *     name?: string,
 *     logo?: string,
 *     requiredFields?: Array<{ id: string, name: string, order: number }>,
 *     isActive?: boolean
 *   }
 * }} option
 */
export const UpdateMainPlatform = async (option) => {
  const response = await $api.put(
    Endpoints.LeadSource.UpdateMainPlatform({ params: option.params }),
    option.body
  );
  return ResponseChecker(defaultMessages, response);
};

/** @param {{ params: { id: string } }} option */
export const DeleteMainPlatform = async (option) => {
  const response = await $api.delete(
    Endpoints.LeadSource.DeleteMainPlatform(option)
  );
  return ResponseChecker(defaultMessages, response);
};

/** @param {{ query?: { mainPlatformId?: string, isActive?: boolean, page?: number, limit?: number } }} [option] */
export const GetPlatforms = async (option) => {
  const response = await $api.get(Endpoints.LeadSource.GetPlatforms(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{
 *   mainPlatformId: string,
 *   code: string,
 *   name: string,
 *   isActive?: boolean
 * }} form
 */
export const CreatePlatform = async (form) => {
  const response = await $api.post(Endpoints.LeadSource.CreatePlatform(), form);
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{
 *   params: { id: string },
 *   body: {
 *     mainPlatformId?: string,
 *     code?: string,
 *     name?: string,
 *     isActive?: boolean
 *   }
 * }} option
 */
export const UpdatePlatform = async (option) => {
  const response = await $api.put(
    Endpoints.LeadSource.UpdatePlatform({ params: option.params }),
    option.body
  );
  return ResponseChecker(defaultMessages, response);
};

/** @param {{ params: { id: string } }} option */
export const DeletePlatform = async (option) => {
  const response = await $api.delete(Endpoints.LeadSource.DeletePlatform(option));
  return ResponseChecker(defaultMessages, response);
};

/** @param {{ query?: { leadPlatformId?: string, productBrandId?: string, parasutAccountId?: string, type?: "Unknown"|"Campaign"|"AdSet"|"Ad"|"Form"|"Bot", isActive?: boolean, page?: number, limit?: number } }} [option] */
export const GetCampaigns = async (option) => {
  const response = await $api.get(Endpoints.LeadSource.GetCampaigns(option));
  return ResponseChecker(defaultMessages, response);
};

/** @param {{ params: { id: string } }} option */
export const GetCampaignById = async (option) => {
  const response = await $api.get(Endpoints.LeadSource.GetCampaignById(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{
 *   leadPlatformId: string,
 *   externalId: string,
 *   name: string,
 *   type?: "Unknown"|"Campaign"|"AdSet"|"Ad"|"Form"|"Bot"|null,
 *   parentId?: string | null,
 *   productBrandIds?: string[],
 *   isActive?: boolean,
 *   parasutAccountId?: string
 * }} form
 */
export const CreateCampaign = async (form) => {
  const response = await $api.post(Endpoints.LeadSource.CreateCampaign(), form);
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{
 *   params: { id: string },
 *   body: {
 *     leadPlatformId?: string,
 *     externalId?: string,
 *     name?: string,
 *     type?: "Unknown"|"Campaign"|"AdSet"|"Ad"|"Form"|"Bot"|null,
 *     parentId?: string | null,
 *     productBrandIds?: string[],
 *     isActive?: boolean,
 *     parasutAccountId?: string
 *   }
 * }} option
 */
export const UpdateCampaign = async (option) => {
  const response = await $api.put(
    Endpoints.LeadSource.UpdateCampaign({ params: option.params }),
    option.body
  );
  return ResponseChecker(defaultMessages, response);
};

/** @param {{ params: { id: string } }} option */
export const DeleteCampaign = async (option) => {
  const response = await $api.delete(Endpoints.LeadSource.DeleteCampaign(option));
  return ResponseChecker(defaultMessages, response);
};

/** @param {{ query?: { leadCampaignId?: string, isActive?: boolean, page?: number, limit?: number } }} [option] */
export const GetAdvertisements = async (option) => {
  const response = await $api.get(
    Endpoints.LeadSource.GetAdvertisements(option)
  );
  return ResponseChecker(defaultMessages, response);
};

/** @param {{ params: { id: string } }} option */
export const GetAdvertisementById = async (option) => {
  const response = await $api.get(
    Endpoints.LeadSource.GetAdvertisementById(option)
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{
 *   mainPlatformIds: string[],
 *   leadPlatformIds: string[],
 *   leadCampaignIds: string[],
 *   productBrandIds: string[],
 *   externalId?: string,
 *   name: string,
 *   isAllProduct?: boolean,
 *   targetProductBrandIds?: string[],
 *   targetProductCategoryIds?: string[],
 *   targetProductIds?: string[],
 *   isActive?: boolean
 * }} form
 */
export const CreateAdvertisement = async (form) => {
  const response = await $api.post(
    Endpoints.LeadSource.CreateAdvertisement(),
    form
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{
 *   params: { id: string },
 *   body: {
 *     mainPlatformIds?: string[],
 *     leadPlatformIds?: string[],
 *     leadCampaignIds?: string[],
 *     productBrandIds?: string[],
 *     externalId?: string,
 *     name?: string,
 *     isAllProduct?: boolean,
 *     targetProductBrandIds?: string[],
 *     targetProductCategoryIds?: string[],
 *     targetProductIds?: string[],
 *     isActive?: boolean
 *   }
 * }} option
 */
export const UpdateAdvertisement = async (option) => {
  const response = await $api.put(
    Endpoints.LeadSource.UpdateAdvertisement({ params: option.params }),
    option.body
  );
  return ResponseChecker(defaultMessages, response);
};

/** @param {{ params: { id: string } }} option */
export const DeleteAdvertisement = async (option) => {
  const response = await $api.delete(
    Endpoints.LeadSource.DeleteAdvertisement(option)
  );
  return ResponseChecker(defaultMessages, response);
};

/** @param {{ query?: { mainPlatformId?: string, page?: number, limit?: number } }} [option] */
export const GetSourceKeys = async (option) => {
  const response = await $api.get(Endpoints.LeadSource.GetSourceKeys(option));
  return ResponseChecker(defaultMessages, response);
};

export default {
  GetMainPlatforms,
  CreateMainPlatform,
  UpdateMainPlatform,
  DeleteMainPlatform,
  GetPlatforms,
  CreatePlatform,
  UpdatePlatform,
  DeletePlatform,
  GetCampaigns,
  GetCampaignById,
  CreateCampaign,
  UpdateCampaign,
  DeleteCampaign,
  GetAdvertisements,
  GetAdvertisementById,
  CreateAdvertisement,
  UpdateAdvertisement,
  DeleteAdvertisement,
  GetSourceKeys,
};
